module.exports = __webpack_public_path__ + "4a5d59ccba18e7f3bc5c0c18be3e2ae7.png";